import React from "react";
import { Styleable } from "../../types";

interface PinProps extends Styleable {
  width?: number;
  height?: number;
  number?: number;
}

export default function Pin({ width = 20, height = (width / 29) * 46, ...props }: PinProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4995 40C18.0653 40 20.956 40.7936 20.956 41.7727C20.956 42.7517 18.0653 43.5454 14.4995 43.5454C10.9337 43.5454 8.04297 42.7517 8.04297 41.7727C8.04297 40.7936 10.9337 40 14.4995 40Z"
          fill="white"
          fillOpacity="0.01"
        />
      </g>
      <mask
        id="path-3-outside-1"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="29"
        height="42"
        fill="black"
      >
        <rect fill="white" width="29" height="42" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 40C14.5 40 28 22.3171 28 14.7328C28 7.14836 21.9558 1 14.5 1C7.04416 1 1 7.14836 1 14.7328C1 22.3171 14.5 40 14.5 40Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 40C14.5 40 28 22.3171 28 14.7328C28 7.14836 21.9558 1 14.5 1C7.04416 1 1 7.14836 1 14.7328C1 22.3171 14.5 40 14.5 40Z"
        fill="currentColor"
      />
      <path
        d="M14.5 40L13.7052 40.6068L14.5 41.6479L15.2948 40.6068L14.5 40ZM14.5 40C15.2948 40.6068 15.295 40.6067 15.2951 40.6065C15.2952 40.6063 15.2955 40.606 15.2957 40.6057C15.2962 40.605 15.2969 40.6041 15.2978 40.603C15.2996 40.6006 15.3022 40.5972 15.3056 40.5927C15.3124 40.5837 15.3225 40.5705 15.3356 40.5532C15.3618 40.5186 15.4004 40.4676 15.4506 40.4009C15.5509 40.2677 15.6975 40.0719 15.8836 39.8206C16.2559 39.318 16.787 38.5926 17.4238 37.6988C18.6968 35.9122 20.3959 33.4482 22.0966 30.7427C23.7952 28.0407 25.507 25.0796 26.7975 22.3017C28.0711 19.5603 29 16.8627 29 14.7328H27C27 16.395 26.2414 18.7519 24.9837 21.4591C23.743 24.1299 22.0798 27.0116 20.4034 29.6783C18.7291 32.3416 17.0532 34.7723 15.795 36.5383C15.1662 37.4208 14.6425 38.1361 14.2765 38.6301C14.0936 38.8771 13.9501 39.0687 13.8526 39.1982C13.8039 39.2629 13.7667 39.3121 13.7419 39.3449C13.7294 39.3613 13.7201 39.3736 13.714 39.3816C13.7109 39.3857 13.7086 39.3887 13.7071 39.3906C13.7064 39.3916 13.7059 39.3923 13.7055 39.3927C13.7054 39.3929 13.7053 39.393 13.7052 39.3931C13.7052 39.3932 13.7052 39.3932 14.5 40ZM29 14.7328C29 6.61226 22.5242 0 14.5 0V2C21.3875 2 27 7.68446 27 14.7328H29ZM14.5 0C6.47582 0 0 6.61226 0 14.7328H2C2 7.68446 7.61249 2 14.5 2V0ZM0 14.7328C0 16.8627 0.928888 19.5603 2.20246 22.3017C3.49296 25.0796 5.20477 28.0407 6.90339 30.7427C8.60415 33.4482 10.3032 35.9122 11.5762 37.6988C12.213 38.5926 12.744 39.318 13.1164 39.8206C13.3025 40.0719 13.4491 40.2677 13.5494 40.4009C13.5996 40.4676 13.6382 40.5186 13.6644 40.5532C13.6775 40.5705 13.6876 40.5837 13.6944 40.5927C13.6978 40.5972 13.7004 40.6006 13.7022 40.603C13.7031 40.6041 13.7038 40.605 13.7043 40.6057C13.7045 40.606 13.7048 40.6063 13.7049 40.6065C13.705 40.6067 13.7052 40.6068 14.5 40C15.2948 39.3932 15.2948 39.3932 15.2948 39.3931C15.2947 39.393 15.2946 39.3929 15.2945 39.3927C15.2941 39.3923 15.2936 39.3916 15.2929 39.3906C15.2914 39.3887 15.2891 39.3857 15.286 39.3816C15.2799 39.3736 15.2706 39.3613 15.2581 39.3449C15.2333 39.3121 15.1961 39.2629 15.1474 39.1982C15.0499 39.0687 14.9064 38.8771 14.7235 38.6301C14.3575 38.1361 13.8338 37.4208 13.205 36.5383C11.9468 34.7723 10.2709 32.3416 8.59661 29.6783C6.92023 27.0116 5.25704 24.1299 4.01629 21.4591C2.75861 18.7519 2 16.395 2 14.7328H0Z"
        fill="white"
        mask="url(#path-3-outside-1)"
      />
      <circle fill="white" cx={14.5} cy={14.5} r={5} />
      <defs>
        <filter
          id="filter0_d"
          x="6.04297"
          y="38"
          width="16.913"
          height="7.54546"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
